import i18n from '@/i18n';
import store from '@/store';

function getCurrentLocale(to) {
  const routeLocale = Array.isArray(to.params?.locale) ? to.params.locale[0] : to.params?.locale;
  if (routeLocale) {
    return routeLocale;
  }

  return typeof i18n.global.locale === 'object' ? i18n.global.locale.value : i18n.global.locale;
}

export async function loyaltyProgramCheckMiddleware(to, from, next) {
  // Skip middleware for public routes like login
  if (!to.meta.requiresAuth || to.name === 'login' || to.meta.authArea === 'sales-crm') {
    return next();
  }

  // if (/\/.{2}\/login$/.test(to.path)) return next();
  
  const activeLoyalty = await store.dispatch('loyaltyStatus/fetchStatus');
  const activeLoyaltyName = Array.isArray(activeLoyalty) ? activeLoyalty[0] : null;
  // console.log("middleware :activeLoyalty", activeLoyalty);

  // If on pselection and no active loyalties, allow navigation
  if (to.name === 'pselection' && !activeLoyaltyName) {
    return next();
  }

  // If on pselection with active loyalties, redirect to first loyalty
  if (to.name === 'pselection' && activeLoyaltyName) {
    return next({
      name: activeLoyaltyName,
      params: { locale: getCurrentLocale(to) },
    });
  }
  return next();
}
